import { render, staticRenderFns } from "./ClockEnd.vue?vue&type=template&id=fbafe3e4"
import script from "./ClockEnd.vue?vue&type=script&lang=js"
export * from "./ClockEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports